import React from 'react';
export const TextOutput = (props: any) => (
  <div style={{ width: 50, textAlign: 'center', color: '#F35C28', fontWeight: 'bolder', fontSize: '18px', ...(props.style || {}) }}>
    {props.value}
  </div>
);